<template>
  <v-card>
    <v-form @submit="submit" onSubmit="return false;">
      <v-card-title class="headline">
        Фильтр
        <v-spacer></v-spacer>
        <v-btn icon class="mx-0" @click="$emit('close-dialog')">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container class="pa-0" grid-list-lg>
          <v-layout row wrap>
            <v-flex xs12 sm6><v-text-field label="Название" v-model="filter.name" clearable hide-details></v-text-field></v-flex>
            <v-flex xs12 sm6><v-text-field label="ID" v-model="filter.id" clearable hide-details></v-text-field></v-flex>
            <v-flex xs12 sm6><v-text-field label="ID владельца" v-model="filter.account_id" clearable hide-details></v-text-field></v-flex>
            <v-flex xs12 sm6><v-select v-model="filter.status" :items="boolValues" label="Активная" hide-details></v-select></v-flex>
            <v-flex xs12 sm6><v-select v-model="filter.default" :items="boolValues" label="Личный кабинет" hide-details></v-select></v-flex>
          </v-layout>
        </v-container>
      
      </v-card-text>
      <v-card-actions class="pa-3">
        <v-btn class="info" type="submit">Поиск</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
  export default {
    name : "CompaniesFilterForm",
    
    props: {
      data: {
        type: Object,
        required: false,
        default: () => ({
          name: '',
          id: '',
          account_id: '',
          status: null,
          default: null
        })
      }
    },
    
    data: () => ({
      filter: {},
      boolValues:[
        { text:'Не выбрано', value: null },
        { text:'Нет', value: false },
        { text:'Да', value: true }
      ],
    }),
    
    created(){
      this.filter = JSON.parse(JSON.stringify(this.data))
    },
    
    methods:{
      submit(){
        this.$emit('save', {type: 'filter', data: this.filter})
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/apps/orgstructure/components/Forms/CompaniesFilterForm.vue